import { getUnits } from './CoordinatesUtils';
import { get as getProjection, METERS_PER_UNIT as OL_METERS_PER_UNIT } from 'ol/proj';

export const DEFAULT_DPI = 72;  // 25.4 / 0.28;
export const DEFAULT_SCREEN_DPI = DEFAULT_DPI;  //96;

export const METERS_PER_UNIT = OL_METERS_PER_UNIT;

export const INCHES_PER_UNIT = {
    'inches': 1.0,
    'ft': 12.0,
    'mi': 63360.0,
    'm': 39.37,
    'km': 39370,
    'dd': 4374754,
    'degrees': 4374754,
    'yd': 36
};

export const GOOGLE_MERCATOR = {
    RADIUS: 6378137,
    TILE_WIDTH: 256,
    ZOOM_FACTOR: 2
};

export const SCALES_DEFAULT = [
    250000,
    100000,
    50000,
    25000,
    10000,
    5000,
    2500,
    2000,
    1000,
    500,
    250,
];

/**
 * @param dpi {number} dot per inch resolution
 * @return {number} dot per meter resolution
 */
export function dpi2dpm(dpi) {
    const inchesPerMeter = 1000 / 25.4;
    return dpi * inchesPerMeter;
}

/**
 * @param dpi {number} screen resolution in dots per inch.
 * @param projection {string} map projection.
 * @return {number} dots per map unit.
 */
export function dpi2dpu(dpi, projection) {
    const units = getUnits(projection || "EPSG:3857");
    return METERS_PER_UNIT[units] * dpi2dpm(dpi || DEFAULT_SCREEN_DPI);
}

/**
 * @param radius {number} Earth's radius of the model in meters.
 * @param tileWidth {number} width of the tiles used to draw the map.
 * @param zoomFactor {number} zoom factor.
 * @param zoomLvl {number} target zoom level.
 * @param dpi {number} screen resolution in dot per inch.
 * @return {number} the scale of the showed map.
 */
export function getSphericalMercatorScale(radius, tileWidth, zoomFactor, zoomLvl, dpi) {
    return 2 * Math.PI * radius / (tileWidth * Math.pow(zoomFactor, zoomLvl) / dpi2dpm(dpi || DEFAULT_SCREEN_DPI));
}

/**
 * @param zoomLvl {number} target zoom level.
 * @param dpi {number} screen resolution in dot per inch.
 * @return {number} the scale of the showed map.
 */
export function getGoogleMercatorScale(zoomLvl, dpi) {
    return getSphericalMercatorScale(GOOGLE_MERCATOR.RADIUS, GOOGLE_MERCATOR.TILE_WIDTH, GOOGLE_MERCATOR.ZOOM_FACTOR, zoomLvl, dpi);
}

export const getResolutionFromScale = (srs, scale, dpi) => {
    if(!scale) return;

    const projection = getProjection(srs || "EPSG:3857");
    const metersPerUnit = projection.getMetersPerUnit();
    const units = projection.getUnits();
    let unitsRatio = INCHES_PER_UNIT[units];
    const resolution = scale / (metersPerUnit * unitsRatio * (dpi || DEFAULT_SCREEN_DPI));
    return resolution;
};

export function getScale(projection, dpi, resolution) {
    const dpu = dpi2dpu(dpi, projection);
    return resolution * dpu;
}

export const getScaleFromResolution = (projection, resolution, dpi, nearest = true) => {
    if(!projection) return;
    let scale = getScale(projection, dpi, resolution);
    return nearest ? Math.round(scale) : scale;
    // const projection = getProjection(epsg);
    // if(projection && resolution){
    //     let scale = getScale(projection)
    //     const _units = projection.getUnits();
    //     const _mpu = projection.getMetersPerUnit();
    //     const _dpi = dpi || DEFAULT_SCREEN_DPI;
    //     const _inchesPerMeter = 1000 / 25.4;
    //     const scale = parseFloat(resolution.toString()) * _mpu * _inchesPerMeter * _dpi;
    //     return nearest ? Math.round(scale) : scale;
    // }
    // return null;
};